import script from "./BusMinView.vue?vue&type=script&setup=true&lang=js"
export * from "./BusMinView.vue?vue&type=script&setup=true&lang=js"

import "./BusMinView.vue?vue&type=style&index=0&id=7f6a4627&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f6a4627"]])

export default __exports__